module.exports = "pegasus_template/assets/frame-facebook.png";